export default {
  yearly: [],
  monthly: [],
  topYear: {},
  topDay: {},
  topDayProduct: {},
  topMonth: {},
  topWeek: {},
  expiringProducts: []
};
